export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14580.8b8b6ca0.jpg";